import { Component, ViewChild, ViewEncapsulation, OnInit } from "@angular/core";

import {
    CellEditInputType,
    CreateMode,
    DisplayMode,
    GridComponent,
    GridValidator,
    IGridColumn,
    IGridSettings,
    ITableSettings,
    UpdateMode
} from "@features/grid";
import { FilterInputType, FilterType } from "@features/filter";
import { RavenPriorityService } from "../raven-priority.service";
import { RavenApiService } from "../raven-api.service";

@Component({
    selector: "raven-priority",
    templateUrl: "raven-priority.component.html",
    styleUrls: []
})
export class RavenPriorityComponent implements OnInit{
    tableSettings: ITableSettings = {
        lazyLoadOnInit: false
    };

    gridSettings: IGridSettings = {
        deleteAllEnabled: true,
        updateMode: UpdateMode.Inline,
        createMode: CreateMode.Disabled,
        filtersRow: false,
        exportEnabled: false,
        deletingAvailable: (rowData => rowData.canDelete),        
    };
    @ViewChild("grid", { static: true }) grid: GridComponent;

    constructor(public ravenPriorityService: RavenPriorityService, public ravenApiService: RavenApiService) {
        this.gridSettings.dataService = ravenPriorityService;
        this.init();
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit(): void {
        
    }

    check() {
        this.ravenApiService.checkPriorities().finally(() => {
            this.grid.reload();
        })
    }


    private async init(): Promise<any> {
        this.tableSettings = {
            columns: <IGridColumn[]>[
                {
                    header: "Id",
                    field: "id",
                    visible: false
                },
                {
                    header: "Name",
                    field: "name"
                },
                {
                    header: "Weight",
                    field: "weight",
                },
                {
                    header: "Colour Hash",
                    field: "colourHash",
                },
                {
                    header: "Suggested",
                    field: "suggested",
                    cellEditingInputType: CellEditInputType.Checkbox,
                    displayMode: DisplayMode.Checkbox
                },              
                {
                    header: "Is Active",
                    field: "isActive",
                    cellEditingInputType: CellEditInputType.Checkbox,
                    displayMode: DisplayMode.Checkbox
                }              
            ]
        } as ITableSettings;
    }
        
}

